import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import Platforms from "@/pages/Platforms";
import Solutions from "@/pages/Solutions";
import Investments from "@/pages/Investments";
import Landscape from "@/pages/Landscape";
import UseCases from "@/pages/UseCases";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Insight2W from "@/pages/Insight2W";
import AdminLeads from "@/pages/AdminLeads";
import BrandLogos from "@/pages/BrandLogos";
import BrandLogosV2 from "@/pages/BrandLogosV2";
import BrandBanner from "@/pages/BrandBanner";
import DraftStructure from "@/pages/DraftStructure";
import FutureBets from "@/pages/FutureBets";
import Vida from "@/pages/Vida";
import VidaDemo from "@/pages/VidaDemo";
import SIAMProject from "@/pages/SIAMProject";
import Links from "@/pages/Links";
import LogoPreview from "@/pages/LogoPreview";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/platforms" element={<Platforms />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/investments" element={<Investments />} />
          <Route path="/landscape" element={<Landscape />} />
          <Route path="/use-cases" element={<UseCases />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/insights/two-wheeler-dealerships" element={<Insight2W />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
          <Route path="/leads" element={<AdminLeads />} />
          <Route path="/brand" element={<BrandLogos />} />
          <Route path="/brand/v2" element={<BrandLogosV2 />} />
          <Route path="/brand/banner" element={<BrandBanner />} />
          <Route path="/charter" element={<DraftStructure />} />
          <Route path="/draftstructure" element={<DraftStructure />} />
          <Route path="/investments/future-bets" element={<FutureBets />} />
          <Route path="/vidaproject" element={<Vida />} />
          <Route path="/vidaproject/demo" element={<VidaDemo />} />
          <Route path="/projects/SIAM" element={<SIAMProject />} />
          <Route path="/projects/siam" element={<SIAMProject />} />
          <Route path="/links" element={<Links />} />
          <Route path="/logo-preview" element={<LogoPreview />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#121212",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.1)",
            borderRadius: "2px",
            fontFamily: "'IBM Plex Sans', sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
